import { BE_END_CALL } from '@rsos/constants/callStatuses';
import {
  TEXT_FROM_911,
  CALL_TYPES_WHITELIST,
} from '@rsos/constants/callTypesWhitelist';
import { CONNECTED_SITES_CATEGORY } from '@rsos/constants/dataTypeCategories';

// Whitelisted call type identification function(s)
const isTextFrom911 = call => {
  return !!call?.textFrom911?.data;
};

// Filter Functions
const filterBySeatPosition = ({ call, workStation }) => {
  return call?.workstationPositions?.includes(workStation);
};
const filterByActiveCalls = ({ call }) => {
  return !call?.callStatuses?.includes(BE_END_CALL);
};
const filterByAdminCalls = ({ call }) => {
  return call?.isAdmin;
};
const filterByIncidentCalls = ({ call }) => {
  return !call.isAdmin;
};

const FILTER_NAME_TO_FILTER_FUNCTION = {
  seatPosition: filterBySeatPosition,
  activeCalls: filterByActiveCalls,
  adminCalls: filterByAdminCalls,
  incidentCalls: filterByIncidentCalls,
};

const WHITELIST_IDENTIFIER_FUNCTIONS = {
  [TEXT_FROM_911]: isTextFrom911,
};

/**
 * Determine if a call is of a whitelisted type.
 * @param {object} call - an entire call item from the queue
 * @returns
 */
const isWhitelistedCall = call => {
  return CALL_TYPES_WHITELIST.some(type => {
    return WHITELIST_IDENTIFIER_FUNCTIONS[type](call);
  });
};

/**
 * Get if a call is a Connected Sites call
 * The result is used to render `CONNECTED SITES` under the call number in the queue
 * @param {object} call - an entire call item from the queue
 * @returns boolean
 */

export const getIsCallerInConnectedSites = (call = {}) => {
  if (call.additionalData) {
    /** adr structure is { item1: [], item2: [] }
     * check if any adr has a Connected Sites category
     */
    return !!Object.values(call.additionalData).find(i =>
      i.some(a => a.dataCategory === CONNECTED_SITES_CATEGORY),
    );
  }
  return false;
};

/**
 * Tests the call against the active filters
 * @param {*} call object representing the emergency call
 * @param {*} filters object containing the filters
 * @param {*} workStation string value representing the user's current workstation
 * @returns boolean indicating if the call passes the active filters
 */
export const applyCallFilters = (call, filters, workStation) => {
  if (isWhitelistedCall(call)) return true;

  let activeFilters = Object.keys(filters).filter(filter => filters[filter]);

  // If both adminCalls and incidentCalls filters are active, we apply neither filter
  // This avoids all calls being filtered out of the queue
  if (
    activeFilters.includes('adminCalls') &&
    activeFilters.includes('incidentCalls')
  ) {
    activeFilters = activeFilters.filter(
      filter => filter !== 'incidentCalls' && filter !== 'adminCalls',
    );
  }

  return !activeFilters.some(
    filter => !FILTER_NAME_TO_FILTER_FUNCTION[filter]({ call, workStation }),
  );
};
